import { LanguageCode } from '@/gql/graphql'

export interface SupportedLanguage {
  code: LanguageCode
  label: string
  shortLabel: string
}

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: LanguageCode.Pt, label: 'Português', shortLabel: 'PT' },
  { code: LanguageCode.En, label: 'English', shortLabel: 'EN' },
]

export const FALLBACK_LANGUAGE_CODE = LanguageCode.Pt

export interface SwitcherLanguageOption {
  vendureCode: string
  catalogCode: LanguageCode
  label: string
  shortLabel: string
}

function baseSubtag(vendureCode: string): string {
  return vendureCode.split('_')[0]
}

export function getAvailableSwitcherLanguages(
  availableLanguageCodes: readonly string[] | null | undefined
): SwitcherLanguageOption[] {
  if (!availableLanguageCodes?.length) return []

  const seen = new Set<LanguageCode>()
  const result: SwitcherLanguageOption[] = []

  for (const vendureCode of availableLanguageCodes) {
    const match = SUPPORTED_LANGUAGES.find((l) => l.code === baseSubtag(vendureCode))
    if (match && !seen.has(match.code)) {
      seen.add(match.code)
      result.push({ vendureCode, catalogCode: match.code, label: match.label, shortLabel: match.shortLabel })
    }
  }

  return result
}

export function toCatalogCode(vendureCode: string | null | undefined): LanguageCode {
  if (!vendureCode) return FALLBACK_LANGUAGE_CODE
  const match = SUPPORTED_LANGUAGES.find((l) => l.code === baseSubtag(vendureCode))
  return match ? match.code : FALLBACK_LANGUAGE_CODE
}
